import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pn-marketweb-siteheader-login-mypage-button',
  styleUrl: 'pn-marketweb-siteheader-login-mypage-button.scss',
})
export class PnMarketwebSiteheaderLoginMypageButton {
  @Element() hostElement: HTMLElement;
  @Prop() label: string = 'Mina sidor!';
  @Prop() myPageUrl: string;

  render() {
    return (
      <Host>
        <pn-button href={this.myPageUrl}>{this.label}</pn-button>
      </Host>
    );
  }
}
